var arrowDown = "https://shopfront-cdn.tekoapis.com/static/e2d2f7be6dc83ff2.svg";

export { arrowDown as default };
